// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"a552594b","473":"cdad1d2f","549":"47821299"}[chunkId] + ".chunk.js";
};